/**
 * We append our custom shadows to the end of the default MUI shadows array.
 * Our custom shadows start at index 25.
 */
const shadows = {
  popover: '0px 20px 20px rgba(0, 0, 0, 0.25)',
};

export default shadows;
